<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <div class="personal-details">
         
          <!-- <h4 class="personal-details-title">Filter Existing Customer</h4> -->
          <div class="filter-block">
            <div class="filter-select">
                <select name="" id="" [(ngModel)]="filterBy" class="form-control">
                    <option value="" selected disabled>Select filter</option>
                    <option value="mobile">Mobile</option>
                    <option value="deviceId">Device Id</option>
                </select>
            </div>
            <div class="filter-input">
                <input type="text" [(ngModel)]="filterByMobileOrEmailOrDeviceId" class="form-control">
            </div>
            <div class="filter-search">
                <button class="btn btn-success" (click)="getExistingCustomerByFilter()">Search</button>
            </div>

          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th scope="col">Customer Id</th>
                <th scope="col">Name</th>
                <th scope="col">Mobile</th>
                <th scope="col">Email Id</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let x of ECdata | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count
                };let i = index">
                <td scope="col">{{x.customerId}}</td>
                <td scope="col">{{x.name}}</td>
                <td scope="col">{{x.mobileNo}}</td>
                <td scope="col">{{x.email}}</td>
                <td scope="col">{{x.latestStatus}}</td>
                <td>
                  <i class="bi bi-eye-fill" (click)="getECbyId(x.existingCustomerInfoId)" data-toggle="modal" data-target="#exampleModalCenter"></i>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="data.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="prospect-block" *ngFor="let data of data">
          <div class="prospect-content">
            <div class="application-details">
              <p class="application-title">Personal Details:</p>
              <div class="row application-form-details">
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">customer Id</label>
                  <p>{{data.customerId}}</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Name</label>
                  <p *ngIf="data.name != ''">{{data.name}}</p>
                  <p *ngIf="data.name == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Mobile</label>
                  <p>{{data.mobileNo}}</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Alternate Mobile</label>
                  <p *ngIf="data.altMobileNo != ''">{{data.altMobileNo}}</p>
                  <p *ngIf="data.altMobileNo == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Email</label>
                  <p *ngIf="data.email != ''">{{data.email}}</p>
                  <p *ngIf="data.email == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Alternate Email</label>
                  <p *ngIf="data.altEmail != ''">{{data.altEmail}}</p>
                  <p *ngIf="data.altEmail == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Installation Address</label>
                  <p *ngIf="data.installationAddress != ''">{{data.installationAddress}}</p>
                  <p *ngIf="data.installationAddress == ''">--</p>
                </div>

                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Application Form For</label>
                  <p *ngIf="data.applicationFormFor != ''">{{data.applicationFormFor}}</p>
                  <p *ngIf="data.applicationFormFor == ''">--</p>
                </div>

                <div class="col-md-4 col-lg-4 application-form">
                  <label for="">Status</label>
                  <p *ngIf="data.latestStatus != ''">{{data.latestStatus}}</p>
                  <p *ngIf="data.latestStatus == ''">--</p>
                </div>
              </div>
            </div>
  
        

            <div class="identity-proof-details">
              <p class="identity-proof-title">Building Proof:</p>
              <div class="row identity-proof-form-details">
                <div class="col-md-12 col-lg-12 identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.buildingUrl}}" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
  
            <div class="identity-proof-details">
              <p class="identity-proof-title">Identity Proof:</p>
              <div class="row identity-proof-form-details">
                <div class="col-md-12 col-lg-12 identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.idProofUrl}}" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details">
              <p class="identity-proof-title">Photo Proof:</p>
              <div class="row identity-proof-form-details">
                <div class="col-md-12 col-lg-12 identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.photoUrl}}" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="identity-proof-details">
              <p class="identity-proof-title">Address Proof:</p>
              <div class="row identity-proof-form-details">
                <div class="col-md-12 col-lg-12 identity-proof-form">
                  <div class="proof-images">
                    <div class="image">
                      <img src="{{data.addressProofUrl}}" alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="applicant-details" *ngFor="let list of data.deviceInfoList">
              <p class="applicant-title">Device Details:</p>
              <div class="row applicant-form-details">
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Id</label>
                  <p *ngIf="list.deviceId != ''">{{list.deviceId}}</p>
                  <p *ngIf="list.deviceId == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Type</label>
                  <p *ngIf="list.deviceType != ''">{{list.deviceType}}</p>
                  <p *ngIf="list.deviceType == ''">--</p>
                </div>
                <div class="col-md-4 col-lg-4 applicant-form">
                  <label for="">Device Info</label>
                  <p *ngIf="list.deviceInfo != ''">{{list.deviceInfo}}</p>
                  <p *ngIf="list.deviceInfo == ''">--</p>
                </div>
              
                <div class="col-md-4 col-lg-4 applicant-form devive-proof-form">
                  <label for="">Device Photo</label>
                  <div class="proof-images" *ngIf="list.devicePhotoUrl != ''">
                    <div class="image">
                      <img src="{{list.devicePhotoUrl}}" alt="">
                    </div>
                  </div>
                  <p *ngIf="list.devicePhotoUrl == ''">--</p>

                </div>
              </div>
            </div>
  
          </div>
          <div class="modal-footer">
            <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal" class="btn btn-secondary">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>